$(document).ready(function () {
  /*Scroll top*/
  var scrollTop = $(".scrollTop");
  $(window).scroll(function () {
    var topPos = $(this).scrollTop();
    if (topPos > 0) {
      $(scrollTop).css("opacity", "1", "transform", "scale(1)");
      $(".scrollTop").addClass("vis");
    } else {
      $(scrollTop).css("opacity", "0", "transform", "scale(0)");
      $(".scrollTop").removeClass("vis");
    }
  });
  $(scrollTop).click(function () {
    $("html, body").animate(
      {
        scrollTop: 0,
      },
      600
    );
    return false;
  });

  /*-----MOBILE FOOTER LINKS-----*/
  $(".fttitle").click(function () {
    if ($(window).width() < 577) {
      $(this).toggleClass("linkopen");
      $(this).next('ul').stop().slideToggle();
      $(this).next('.divshowhide').stop().slideToggle();
    }
  });

  // for why choose us section - below screensize 576px
  $(".whychoose_bx dl").click(function () {
    if ($(window).width() < 768) {
      $(this).toggleClass("openwhychoose");
      $(this).next('.whychooseinfo').stop().slideToggle();
      $(this).next('.divshowhide').stop().slideToggle();
    }
  });
  
  /**/
  $('.usps-ul').slick({
			arrows: false,
			dots: false,
			slidesToShow: 4,
			slidesToScroll: 1,
			horizontal: true,
			infinite: true,
			autoplay: false,
			pauseOnHover: false,
			autoplaySpeed: 3000,
			responsive: [
			{
					breakpoint:993,
					settings: {
							slidesToShow: 3,
					}
			},
			{
					breakpoint: 769,
					settings: {
							slidesToShow: 2,
					}
			},
			{
					breakpoint:577,
					settings: {
							slidesToShow:1,
							centerMode:true,
							centerPadding:'50px'
					}
			}
			]
});

});
